let taskChannel: MessageChannel | undefined;
const taskWaiters: (() => void)[] = [];
type TaskPort = MessagePort & { ref?(): void; unref?(): void };

/** A real task boundary lets input and rendering run between creature compiles. */
export async function yieldBetweenMemberCompiles(): Promise<void> {
    const scheduler = (globalThis as { scheduler?: { yield(): Promise<void> } }).scheduler;
    if (scheduler?.yield) { await scheduler.yield(); return; }
    const immediate = (globalThis as { setImmediate?: (callback: () => void) => unknown }).setImmediate;
    if (immediate) { await new Promise<void>(resolve => immediate(resolve)); return; }
    await new Promise<void>(resolve => {
        // Worker/Node fallbacks can yield thousands of times for one transport.
        // Reuse the task source instead of allocating and closing two ports each time.
        if (!taskChannel) {
            taskChannel = new MessageChannel();
            (taskChannel.port2 as TaskPort).unref?.();
            taskChannel.port1.onmessage = () => {
                const next = taskWaiters.shift()!;
                if (!taskWaiters.length) (taskChannel!.port1 as TaskPort).unref?.();
                next();
            };
        }
        taskWaiters.push(resolve);
        (taskChannel.port1 as TaskPort).ref?.();
        taskChannel.port2.postMessage(null);
    });
}
